import { render, staticRenderFns } from "./column-netto.vue?vue&type=template&id=ce25396a&"
import script from "./column-netto.vue?vue&type=script&lang=js&"
export * from "./column-netto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports